<template>
    <zen-message-modal :isOpen="isOpen" title="Revoke permission?">
        Revoking this permission will remove the
        <strong>{{ grant?.role }}</strong> role at
        <strong>{{ scopeLabel(grant) }}</strong> from
        <strong>{{ userName }}</strong
        >.
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
                data-testid="confirm-revoke-button"
            >
                Revoke
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RevokeUserGrantModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        grant: {
            type: Object,
            default: null,
        },
        userName: {
            type: String,
            default: '',
        },
        processing: {
            type: Boolean,
            default: false,
        },
        scopeLabel: {
            type: Function,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
